import type { ProjectScope } from '../sync/project-scope.ts';
import {
    enqueueStructuredEntityWrite,
    type StructuredEntityWriteRegistration,
} from '../sync/structured-entity-write.ts';

type PromptBookWriteOptions = {
    actorId?: string;
};

const CUE_ANCHOR_WRITE_REGISTRATION: StructuredEntityWriteRegistration = {
    feature: 'script_show',
    capability: 'EDIT_RUNSHEET',
    conflictPrefix: 'cueAnchors',
    allowedKinds: ['patchEntity', 'deleteEntity'],
    authErrorMessage: 'Authentication required to preserve prompt book project writes',
};

export async function deleteCueAnchor(
    scope: ProjectScope,
    cueAnchorId: string,
    options: PromptBookWriteOptions = {}
): Promise<void> {
    await enqueueStructuredEntityWrite({
        scope,
        registration: CUE_ANCHOR_WRITE_REGISTRATION,
        entityId: cueAnchorId,
        kind: 'deleteEntity',
        payload: { id: cueAnchorId },
        actorId: options.actorId,
    });
}
